package com.mgacreative.hotelru.core.tenant

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json

@Serializable
data class SessionState(
    val userId: String? = null,
    val email: String? = null,
    val fullName: String? = null,
    val hotelName: String? = null,
    val phone: String? = null,
    val tenantId: String? = null,
    val memberCode: String? = null,
    val role: UserRole = UserRole.SUPER_ADMIN,
    val roles: List<String> = emptyList(),
    val isDemoMode: Boolean = false,
    val isAuthenticated: Boolean = false
)

class TenantSession {
    private val jsonSerializer = Json { 
        ignoreUnknownKeys = true 
        encodeDefaults = true
    }

    private val _sessionState = MutableStateFlow(loadInitialSession())
    val sessionState: StateFlow<SessionState> = _sessionState.asStateFlow()

    private fun loadInitialSession(): SessionState {
        return try {
            val savedJson = PlatformSessionStore.loadSession()
            if (!savedJson.isNullOrBlank()) {
                jsonSerializer.decodeFromString(SessionState.serializer(), savedJson)
            } else {
                SessionState()
            }
        } catch (_: Throwable) {
            SessionState()
        }
    }

    val currentUserId: String?
        get() = _sessionState.value.userId

    val currentEmail: String?
        get() = _sessionState.value.email

    val currentFullName: String?
        get() = _sessionState.value.fullName

    val currentHotelName: String?
        get() = _sessionState.value.hotelName

    val currentPhone: String?
        get() = _sessionState.value.phone

    val currentTenantId: String?
        get() = _sessionState.value.tenantId

    val currentMemberCode: String?
        get() = _sessionState.value.memberCode

    val currentRole: UserRole
        get() = _sessionState.value.role
        
    val currentRoles: List<String>
        get() = _sessionState.value.roles

    val isDemoMode: Boolean
        get() = _sessionState.value.isDemoMode

    fun updateSession(
        userId: String,
        tenantId: String,
        role: UserRole = UserRole.SUPER_ADMIN,
        roles: List<String> = emptyList(),
        memberCode: String? = null,
        email: String? = null,
        fullName: String? = null,
        hotelName: String? = null,
        phone: String? = null,
        isDemoMode: Boolean = false
    ) {
        val newState = SessionState(
            userId = userId,
            email = email,
            fullName = fullName,
            hotelName = hotelName,
            phone = phone,
            tenantId = tenantId,
            memberCode = memberCode,
            role = role,
            roles = roles,
            isDemoMode = isDemoMode,
            isAuthenticated = true
        )
        _sessionState.value = newState
        try {
            PlatformSessionStore.saveSession(jsonSerializer.encodeToString(SessionState.serializer(), newState))
        } catch (_: Throwable) {}
    }

    fun clearSession() {
        _sessionState.value = SessionState()
        try {
            PlatformSessionStore.clearSession()
        } catch (_: Throwable) {}
    }
    
    // Yardımcı: Sadece admin mi?
    fun isSuperAdmin(): Boolean = currentRole == UserRole.SUPER_ADMIN
    
    // Yardımcı: Belirli bir role sahip mi?
    fun hasRole(roleName: String): Boolean {
        // Eğer SUPER_ADMIN veya HOTEL_OWNER ise her şeye yetkisi olsun
        if (currentRole == UserRole.SUPER_ADMIN || currentRole == UserRole.HOTEL_OWNER) return true
        return currentRoles.contains(roleName)
    }
}

